import { SET_USER, SUBSCRIBER_FILTER_CHANGED, SUBSCRIBER_ORDER_CHANGED, ADD_FAVORITE, REMOVE_FAVORITE, ADD_FILTER, DELETE_FILTER, DISMISS_MAINTENANCE_INFO } from '../constants/actions'
import { AVAILABLE, OCCUPIED } from '../constants/status'

const DEFAULT_FILTER = { status: [AVAILABLE, OCCUPIED] }

const INITIAL_STATE = {
    filter: DEFAULT_FILTER,
    favorites: [],
    filters: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER:
            return action.user.preferences ? { ...action.user.preferences } : INITIAL_STATE
        case SUBSCRIBER_FILTER_CHANGED:
            return { ...state, filter: action.filter || DEFAULT_FILTER }
        case SUBSCRIBER_ORDER_CHANGED:
            return { ...state, sortOrder: action.sortOrder }
        case ADD_FAVORITE: {
            if (!state.favorites.indexOf(action.subscriber) >= 0) {
                return { ...state, favorites: [...state.favorites, action.subscriber] }
            }
        }
        case REMOVE_FAVORITE: {
            return { ...state, favorites: [...state.favorites.filter(f => f !== action.subscriber)] }
        }
        case ADD_FILTER: {
            return { ...state, filters: [...state.filters, { name: action.name, filter: action.filter }] }
        }
        case DELETE_FILTER: {
            return { ...state, filters: [...state.filters.filter(f => f.name !== action.name)] }
        }
        case DISMISS_MAINTENANCE_INFO: {
            return { ...state, dismissedMaintenanceInfo: action.id }
        }
    }
    return state
}


// WEBPACK FOOTER //
// ./reducers/preferences.js